export default class AppConfig {
    
    public static gameLoaded:boolean = false;
    
    public static BUILD_NUMBER:string = "1.0.4"; // Major Number, Minor Number, Build Number
    public static TOOLTIP_DELAY:number = 500;

    public static text:any = {
        landing: {
            subHeading: "Do you know...",
            title: "Insert Title",
            description: "You can add a title and description for your learning game in the admin settings",
        },
        game: {
            gameOver: "<h2>Congratulations!</h2>You've made it to the end!",
            playerDied: "<h2>Bad Decision!</h2>You haven't made it to the end!",
        }
    }

    // THIS MUST MATCH THE 'THEME NAME' in the game
    public static SETTINGS_THEME_NAMES = {
        treasureHunter: "Cave Exploration",
        cityHunter: "City Dash",
        cyberSecurity: "Cyber Security",
        bridgeBuilder: "Bridge Building",
        hospital: "Hospital",
        army: "Military",
        construction: "Construction",
        office: "Office",
        school: "School",
        marsExploration: "Mars Exploration",
    }

    public static SETTINGS_VEHICLE_NAMES = {
        Car: "Car",
        Taxi: "Taxi",
        FireEngine: "Fire Engine",
        Ambulance: "Ambulance",
        PoliceCar: "Police Car",
        Bus: "Bus",
    }

    public static SETTINGS_STAT_NAMES = {
        Health: "Health",
        Money: "Money",
        Security: "Security",
        Economy: "Economy",
        Popularity: "Popularity",
        Satisfaction: "Satisfaction",
        People: "People",
        Barrels: "Barrels",
        Oil: "Oil",
        Fire: "Fire",
        Efficiency: "Efficiency",
        Speed: "Speed",
        Weight: "Weight",
    }

    public static SETTINGS_CURRENCY_NAMES = {
        GBP: "£",
        USD: "$",
        EURO: "€",
        BITCOIM: "₿",
        NONE: ""
    }

    public static TAG_SUGGESTIONS = [
        { id: 'USA', text: 'USA' },
        { id: 'Germany', text: 'Germany' },
        { id: 'Austria', text: 'Austria' },
        { id: 'Costa Rica', text: 'Costa Rica' },
        { id: 'Sri Lanka', text: 'Sri Lanka' },
        { id: 'Thailand', text: 'Thailand' }
     ]

    // public static settings:any = {
    //     theme: AppConfig.SETTINGS_THEME_NAMES.treasureHunter,
    //     vehicle: AppConfig.SETTINGS_VEHICLE_NAMES.Bus,
    //     stat: AppConfig.SETTINGS_STAT_NAMES.Health,
    //     prefix: "",
    //     suffix: "",
    // }

    public static MOBILE_WIDTH:number = 500;
    public static INCOGNITO:boolean = true;

    // public static STATE_GAME_OVER_FAIL:string = "Game Over Fail";
    // public static STATE_GAME_OVER_RESTART:string = "Restart Game";
    // public static STATE_NEXT_CHAPTER:string = "Next Chapter";
    // public static STATE_GAME_OVER_SUCCESS:string = "Game Over Success";

    public static COPY_NO_STORY_TEXT:string = "<h2>Dead End!</h2>Oops! If you are the author of this game please add a page for this decision";
    public static COPY_MILESTONE_TEXT:string = "We've reached a milestone! Let's see how you're doing..."

    public static userData:any;
}


// WEBPACK FOOTER //
// ./src/config/AppConfig.tsx